import { fetchCustomerServiceAMCPageData } from '@/actions/fetchAmcPlanDetails';
import PageLayout from '@/components/Layouts/PageLayout';
import STATIC_MAP from '@/components/Static/map';
import ssrErrorHandler from '@/errors/ssrErrorHandler';
import useGTM from '@/hooks/useGTM';
import useLayoutRenderer from '@/hooks/useLayoutRenderer';
import useOnMount from '@/hooks/useOnMount';
import useScreen from '@/hooks/useScreen';
import Container from '@/shared/Container';
import Div from '@/shared/Div';
import { GTMEventNames } from '@/types/gtm';
import { NextPageContext } from 'next';

export async function getServerSideProps(nextPageContext: NextPageContext) {
  try {
    const page = await fetchCustomerServiceAMCPageData();
    return {
      props: {
        page,
      },
    };
  } catch (error) {
    return ssrErrorHandler(error, nextPageContext);
  }
}
const background = 'linear-gradient(180deg, #FFF 0%, #DEE9F2 100%)';
export default function CustomerServiceAndAMCPage({ page, host }: { page: any; host?: string }) {
  const { isMobile } = useScreen();
  const layout = useLayoutRenderer(page.layout, STATIC_MAP);
  const { fireGTMEvent } = useGTM();

  useOnMount(() => {
    fireGTMEvent(GTMEventNames.WEB_SERVICE_PAGE_LANDING, {});
  });

  return (
    <PageLayout hideFooterIcons seo={page.seo} pageWrapperClassName="pb-18 md:pb-20">
      <Div
        className="pb-28"
        style={{
          background,
        }}
      >
        <Container className="flex flex-col gap-s6 w-full md:max-w-none">{layout}</Container>
      </Div>
    </PageLayout>
  );
}
